module.exports = __webpack_public_path__ + "static/media/loc3_img10.93895dae.jpg";